module.exports = __webpack_public_path__ + "img/imgCta22.bbd09114.png";